import React from "react";
import DatePicker from "react-datepicker";
import { DatepickerLabel, DatepickerWrapper } from "./styles";
import './datepicker.css'

import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = (props) => {
  return (
    <div className="">
      <DatepickerLabel >{props.placeholder}</DatepickerLabel>
      <DatePicker
        selected={props.date}
        onChange={props.handleDateChange}
        maxDate={new Date()}
        dateFormat="MMM dd, yyyy"
        className="picker"
      />
    </div>
  );
};

export default CustomDatePicker;
